import {Card, Row, Tooltip} from "antd";
import Dot from "../../../Components/Dot";
import NivoPieChart from "../../../charts/nivo/NivoPieChart";
import React, {useMemo} from "react";



const calculateTotalDelta = (currentData, previousData) => {
    if (!previousData) return null;

    const currentTotal = Object.values(currentData).reduce((sum, value) =>
        typeof value === 'number' ? sum + value : sum, 0);
    const previousTotal = Object.values(previousData).reduce((sum, value) =>
        typeof value === 'number' ? sum + value : sum, 0);

    return currentTotal - previousTotal;
}



const PieGridLegend = ({colorMapping}) => {
    return (
        <Row justify={'start'} className={'px-6'}>
            {Object.keys(colorMapping).map((key, index) => (
                <div className={'mx-2'}>
                    <Dot color={colorMapping[key]} label={key} size={'14px'} />
                </div>
            ))}
        </Row>
    )
}


const formatter = (data)=>{
    const pieData = [];
    for (const key in data){
        if (!['totalDelta'].includes(key))
        pieData.push({id: key, label: key, value: data[key]});
    }
    return pieData;
}



/**
 *
 * @param chartData {Array[object]} Example:
 *     [
 *      { id: '2018-01-31', blend: 22.12, growth: 61.8, value: 16.08 },
 *      { id: '2018-02-28', blend: 22.52, growth: 61.2, value: 16.28 },
 *      { id: '2018-03-29', blend: 23.52, growth: 60.2, value: 16.28 },
 *      { id: '2018-04-30', blend: 18.6, growth: 61.4, value: 19.58 }
 *     ]
 * @param colorMapping {Object} - Mapping where keys represent all fields not 'id' that map to hex color codes
 * @param fieldNames {Array[string]} - Array of field names that should be included in the pie chart
 * @param rows {number} - Number of rows to display in the grid
 * @returns {JSX.Element}
 * @constructor
 */
const PieGrid = ({ chartData, colorMapping, fieldNames, rows = 12, showDelta = false }) => {
    const formattedChartData = useMemo(() => {
        return chartData.map((data, index) => ({
            ...data,
            totalDelta: showDelta ? Math.abs(calculateTotalDelta(data, chartData[index - 1])) : null
        }));
    }, [chartData, showDelta]);

    return (
        <Card
            bordered={false}
            style={{
                maxHeight: '800px',
                overflow: 'auto',
            }}
            title={
                <PieGridLegend colorMapping={
                    Object.keys(colorMapping).filter(key => fieldNames.includes(key))
                        .reduce((obj, key) => {
                            obj[key] = colorMapping[key];
                            return obj;
                        }, {})
                } />
            }
        >
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                {formattedChartData.map((data, index) => (
                    <Tooltip key={index} title={showDelta && data.totalDelta !== null ? `Delta: ${data.totalDelta.toFixed(2)}` : null}>
                        <div
                            style={{ height: '80px', width: `calc(100% / ${rows} - 15px)`, margin: '30px 10px' }}
                        >
                            <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '10px', fontWeight: '500' }}>
                                {data.id}
                                {showDelta && data.totalDelta !== null &&  data.totalDelta > 0 && (
                                    <span style={{ marginLeft: '5px', color: data.totalDelta >= 0 ? 'green' : 'red' }}>
                                        ({data.totalDelta >= 0 ? '+' : ''}{data.totalDelta.toFixed(2)})
                                    </span>
                                )}
                            </div>
                            <NivoPieChart
                                data={formatter(data)}
                                customColors={colorMapping}
                                size="tiny"
                            />
                        </div>
                    </Tooltip>
                ))}
            </div>
        </Card>
    );
};



export default PieGrid;